let getToken: () => Promise<string | null> = async () => null;

export function registerAuthTokenGetter(fn: () => Promise<string | null>): void {
  getToken = fn;
}

export async function getAccessTokenForApi(): Promise<string | null> {
  return getToken();
}
